import type { Writable } from 'svelte/store';
import { writable } from 'svelte/store';

interface ThemeStoreState {
  headerBackground: string;
  headerText: string;
  headerCtaBackground: string;
  headerCtaText: string;
  headerMenuIconColor: string;
}

// This is default and will be changed by the layout.sever on page load
export const themeStore: Writable<ThemeStoreState> = writable({
  headerBackground: 'bg-white',
  headerText: 'text-gray-900',
  headerCtaBackground: '#ffffff',
  headerCtaText: '#bbbbbb',
  headerMenuIconColor: '#475467',
});

import { HEADER_VARIANT } from '$lib/constants/constants';

const BLOG_HOME_URL = '/blogs/news';
const BLOG_FITNESS_URL = '/blogs/fitness';
const BLOG_WELLBEING_URL = '/blogs/wellbeing';
const BLOG_NUTRITION_URL = '/blogs/nutrition';
const BLOG_COMMUNITY_URL = '/blogs/community';

export const setTheme = (
  headerVariant,
  headerCtaBackground,
  headerCtaText,
  url,
  headerMenuIconColor,
) => {
  const theme = {
    headerVariant,
    headerBackground: 'bg-white',
    headerText: 'text-gray-600',
    headerCtaBackground,
    headerCtaText,
    headerTriangle: 'before:border-white',
    headerMenuIconColor,
  };

  const lowerCasePath = url.pathname.toLowerCase();

  if (lowerCasePath.includes('/exercises')) {
    theme.headerBackground = 'bg-gray-700';
    theme.headerTriangle = 'before:border-gray-700';
    theme.headerText = 'text-white';
    theme.headerCtaBackground = '#FFFFFF';
    theme.headerCtaText = '#0C111D';
    theme.headerVariant = HEADER_VARIANT.INVERT;
    theme.headerMenuIconColor = '#FFFFFF';
  } else if (lowerCasePath.includes('/trainers') || lowerCasePath.includes('/programs')) {
    theme.headerBackground = 'bg-primary-500';
    theme.headerTriangle = 'before:border-primary-500';
    theme.headerText = 'text-white';
    theme.headerCtaBackground = '#FFFFFF';
    theme.headerCtaText = '#0C111D';
    theme.headerVariant = HEADER_VARIANT.INVERT;
    theme.headerMenuIconColor = '#FFFFFF';
  } else if (lowerCasePath.includes('/blogs')) {
    switch (lowerCasePath) {
      case BLOG_HOME_URL:
        theme.headerBackground = 'bg-gray-200';
        theme.headerText = '#FF1A66';
        theme.headerTriangle = 'before:border-gray-200';
        theme.headerCtaBackground = '#FF1A66';
        theme.headerCtaText = '#FFFFFF';
        theme.headerVariant = HEADER_VARIANT.DEFAULT;
        break;
      case BLOG_FITNESS_URL:
      case BLOG_WELLBEING_URL:
      case BLOG_NUTRITION_URL:
      case BLOG_COMMUNITY_URL:
        theme.headerBackground = 'bg-fuchsia-950';
        theme.headerTriangle = 'before:border-fuchsia-950';
        theme.headerText = 'text-white';
        theme.headerCtaBackground = '#FFFFFF';
        theme.headerCtaText = '#0C111D';
        theme.headerVariant = HEADER_VARIANT.INVERT;
        break;
      default:
        if (headerVariant === HEADER_VARIANT.INVERT) {
          theme.headerBackground = 'bg-gray-950';
          theme.headerTriangle = 'before:border-gray-950';
          theme.headerText = 'text-white';
        }
        break;
    }
  } else {
    if (headerVariant === HEADER_VARIANT.INVERT) {
      theme.headerBackground = 'bg-gray-950';
      theme.headerTriangle = 'before:border-gray-950';
      theme.headerText = 'text-white';
    }
  }
  themeStore.set(theme);
};
